import { render, staticRenderFns } from "./OrderCardHistoryOld.vue?vue&type=template&id=e24937f8&scoped=true&"
import script from "./OrderCardHistoryOld.vue?vue&type=script&lang=js&"
export * from "./OrderCardHistoryOld.vue?vue&type=script&lang=js&"
import style0 from "./OrderCardHistoryOld.vue?vue&type=style&index=0&id=e24937f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24937f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
